export default __webpack_public_path__ + "static/media/door-key.c7acbe03.png";